import classNames from 'classnames';
import { useFormContext, Controller } from 'react-hook-form';
import Select from '../Inputs/Select';
import { FormControl, FormLabel } from '@mui/material';
import { FALL_WITNESSED_OPTIONS } from '@/consts/selectOptions';
import { ReactComponent as DownArrow } from '../../assets/icons/patientProfileIcons/expandMoreIcon.svg';
import styles from './index.module.scss';

const WitnessedField = () => {
  const { control } = useFormContext();
  return (
    <FormControl className={classNames(styles.inputWrapper, styles.selectWrapper)}>
      <FormLabel className={classNames('text-xs tex-left', styles.witnessedLabel)}>
        Witnessed
      </FormLabel>
      <Controller
        name="witnessed"
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            options={FALL_WITNESSED_OPTIONS}
            className={styles.selectRoot}
            variant="standard"
            name="witnessed"
            disableUnderline
            customIcon={DownArrow}
            classes={{
              select: styles.inputField,
              icon: styles.selectIcon,
            }}
          />
        )}
      />
    </FormControl>
  );
};
export default WitnessedField;
